export { FinePrintBanner } from './fine-print-banner'
